import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  User,
  Heart,
  Package,
  MapPin,
  Lock,
  HelpCircle,
  ChevronRight,
} from "lucide-react";

import PersonalInfo from "./PersonalInfo";
import OrderComponents from "./OrderComponets";
import WishlistComponet from "./WishlistComponet";
import AddressComponent from "./AddressComponet";
import NeedHelp from "./NeedHelp";

const EditProfile = () => {
  const [user, setUser] = useState(null);
  const [activeSection, setActiveSection] = useState("profile");
  const location = useLocation();

  // user load
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  // route se section open
  useEffect(() => {
    if (location.state?.section) {
      setActiveSection(location.state.section);
    }
  }, [location.state]);

  return (
  <div className="bg-[#F6F7FB] py-10">
    <div className="max-w-8xl mx-auto px-20">
      
      {/* ✅ IMPORTANT CHANGE */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

        {/* ================= LEFT SIDEBAR ================= */}
        <div className="lg:col-span-4">
          
          {/* ✅ STICKY WRAPPER */}
          <div className="space-y-6 lg:sticky lg:top-[90px] h-fit">

            {/* Profile Card */}
            <div className="bg-white rounded-xl border px-4 py-4 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full border flex items-center justify-center">
                  <User size={24} className="text-gray-400" />
                </div>

                <div>
                  <p className="font-semibold text-gray-900">
                    {user?.name || "User"}
                  </p>
                  <p className="text-sm text-gray-500">
                    {user?.email || user?.phone || ""}
                  </p>
                </div>
              </div>

              <button
                onClick={() => setActiveSection("profile")}
                className="text-teal-600 flex items-center gap-1"
              >
                Edit <ChevronRight size={16} />
              </button>
            </div>

            {/* My Orders */}
            <Section title="My Orders">
              <SidebarItem
                icon={<Package size={18} />}
                title="Orders"
                desc="View, Track, Cancel & Invoice"
                active={activeSection === "orders"}
                onClick={() => setActiveSection("orders")}
              />
              <SidebarItem
                icon={<Heart size={18} />}
                title="My Wishlist"
                desc="View all products in wishlist"
                active={activeSection === "wishlist"}
                onClick={() => setActiveSection("wishlist")}
              />
            </Section>

            {/* My Profile */}
            <Section title="My Profile">
              <SidebarItem
                icon={<User size={18} />}
                title="Personal Info"
                active={activeSection === "profile"}
                onClick={() => setActiveSection("profile")}
              />
              <SidebarItem
                icon={<MapPin size={18} />}
                title="Addresses"
                active={activeSection === "addressinfo"}
                onClick={() => setActiveSection("addressinfo")}
              />
            </Section>

            {/* Help */}
            <Section title="Help">
              <SidebarItem
                icon={<HelpCircle size={18} />}
                title="Need Help"
                active={activeSection === "faq"}
                onClick={() => setActiveSection("faq")}
              />
            </Section>

          </div>
        </div>

        {/* ================= RIGHT CONTENT ================= */}
        <div className="lg:col-span-8 bg-white rounded-xl p-6">
          {activeSection === "profile" && <PersonalInfo user={user} />}
          {activeSection === "orders" && <OrderComponents />}
          {activeSection === "wishlist" && <WishlistComponet />}
          {activeSection === "addressinfo" && <AddressComponent />}
          {activeSection === "faq" && <NeedHelp />}
        </div>

      </div>
    </div>
  </div>
);
};

export default EditProfile;

/* ================= COMPONENTS ================= */

const Section = ({ title, children }) => (
  <div>
    <h4 className="font-semibold text-teal-700 mb-2">{title}</h4>
    <div className="bg-white rounded-xl divide-y border">{children}</div>
  </div>
);

const SidebarItem = ({ icon, title, desc, active, onClick }) => (
  <div
    onClick={onClick}
    className={`flex justify-between items-center p-4 cursor-pointer transition
    ${active ? "bg-[rgb(240_253_250)]" : "hover:bg-gray-50"}`}
  >
    <div className="flex gap-4">
      <div className="text-teal-600">{icon}</div>
      <div>
        <p className={`font-medium ${active ? "text-teal-700" : "text-gray-800"}`}>
          {title}
        </p>
        {desc && <p className="text-sm text-gray-500">{desc}</p>}
      </div>
    </div>

    <ChevronRight
      size={18}
      className={active ? "text-teal-600" : "text-gray-400"}
    />
  </div>
);
